import React, {PureComponent} from 'react';

class UpComingStatus extends PureComponent {
    render() {
        const {translation, defaultTranslation} = this.props;
        return (
            <div className="status-button upcoming-button">
                <span>
                    {translation?.auditorium.upcomingButton ||
                    defaultTranslation?.auditorium.upcomingButton}
                </span>
            </div>
        );
    }
}

export default UpComingStatus;